import className from 'classnames/bind';
import { VideoPlaylistFragment } from '@graphqlTypes';
import { YoutubeImagePreview } from '@/components/VideoEmbed/YoutubeEmbed';

import styles from './VideoPlaylistMobile.module.scss';
import { VideoEmbed } from '@/components/VideoEmbed';
const cx = className.bind(styles);

type Props = Omit<VideoPlaylistFragment, '__typename' | 'primaryVideo' | 'videos'> & {
  primaryVideo?: Omit<VideoPlaylistFragment['primaryVideo'], '__typename'>;
  videos?: Omit<VideoPlaylistFragment['videos'][number], '__typename'>[];
  largeTitle?: boolean;
};

export default function VideoPlaylistMobile(props: Props) {
  const { primaryVideo, videos } = props;

  return (
    <div className={cx("video-playlist-mobile")}>
      <div className={cx("video-item")}>
        <VideoEmbed
          {...primaryVideo}
          className={cx("video-embed")}
        />
        {primaryVideo?.performanceName && (
          <h3 className={cx("video-title", "title-lc-xs")} dangerouslySetInnerHTML={{ __html: primaryVideo.performanceName }} />
        )}
      </div>
      {videos.map((video, index) => (
        <div key={`video-${index}-${video?.youtubeVideoId}`} className={cx("video-item")}>
          <YoutubeImagePreview
            id={video?.youtubeVideoId || ''}
            thumbnail={video?.videoThumbnail || video?.youtubeThumbnail}
            className={cx("video-embed")}
            playVideoLabel={video?.performanceName}
          />
          {video?.performanceName && (
            <h3 className={cx("video-title", "title-lc-xs")} dangerouslySetInnerHTML={{ __html: video.performanceName }} />
          )}
        </div>
      ))}
    </div>
  );
}
